import { ChargeOnCompanyMappingConstant, chargeOnCompanyMappingRequiredFieldList } from "presentation/constant/ChargeOnCompanyMapping/ChargeOnCompanyMappingConstant";
import { statusDropdownOptions } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { useChargeOnCompanyMappingVM } from "presentation/hook/ChargeOnCompanyMapping/useChargeOnCompanyMappingVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useChargeOnCompanyMappingTracked } from "presentation/store/ChargeOnCompanyMapping/ChargeOnCompanyMappingProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { NbisIconButton } from "presentation/view/components/NbisIconButton";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHBreadcrumb, HPHCheckbox, HPHGroupTitle, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, SidebarCaption, Sidebarheader, SidebarTitle, StyledAction, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const ChargeOnCompanyMappingEditPanel = () => {
    const CHARGE_ON_COMPANY_MAPPING_CONSTANT = ChargeOnCompanyMappingConstant.Table;
    const [isLoading, setIsLoading] = useState(false);
    const [chargeOnCompanyMappingState] = useChargeOnCompanyMappingTracked();
    const chargeOnCompanyMappingVM = useChargeOnCompanyMappingVM();
    const { currentEditRow, isAdd, isEdit, masterState } = chargeOnCompanyMappingState;
    const { isSaveClicked, allFormState } = masterState;
    const messageBarVM = useMessageBarVM();
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate } = anaInfoState;


    const handleSave = useCallback(async () => {
        // if (!currentEditRow.chargeOnCompanyCode) {
        //     messageBarVM.showError("Charge-On Company is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.activeInd) {
        //     messageBarVM.showError("Active Ind is mandatory.");
        //     return;
        // }
        setIsLoading(true);
        chargeOnCompanyMappingVM.onSaveClicked();
        const data = await chargeOnCompanyMappingVM.onSave(currentEditRow);
        if (data && data.success) {
            messageBarVM.showSuccess("Save Successfully.");
            chargeOnCompanyMappingVM.searchAllChargeOnCompanyMappingList().then((data) => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        } else {
            setIsLoading(false)
            data.data && messageBarVM.showError(data.data);
            return;
        }
    }, [chargeOnCompanyMappingVM, currentEditRow, messageBarVM]);

    const handClose = useCallback(() => {
        chargeOnCompanyMappingVM.onCloseEidtPanel();
    }, [chargeOnCompanyMappingVM]);

    const memoSubChgTypeOptions = useMemo(() => {
        const subChgTypeOptions = currentEditRow.chargeType ? chargeOnCompanyMappingState.dynamicOptions.subChargeTypeDropdownOptions[currentEditRow.chargeType] : chargeOnCompanyMappingState.dynamicOptions.allSubChargeTypeDropdownOptions;
        return subChgTypeOptions;
    }, [currentEditRow.chargeType, chargeOnCompanyMappingState.dynamicOptions.subChargeTypeDropdownOptions, chargeOnCompanyMappingState.dynamicOptions.allSubChargeTypeDropdownOptions])

    // const memoOpsLineCompanyOptions = useMemo(() => {
    //     if (operatingUnit === 'SAPT' || operatingUnit === 'KICT') {
    //         const opsLineCompanyeOptions = chargeOnCompanyMappingState.dynamicOptions.opsLineCompanyDropdownOptions;
    //         return opsLineCompanyeOptions;
    //     } else {
    //         const opsLineCompanyeOptions = chargeOnCompanyMappingState.dynamicOptions.opsLineDropdownOptions;
    //         return opsLineCompanyeOptions;
    //     }
    // }, [operatingUnit, chargeOnCompanyMappingState.dynamicOptions.opsLineCompanyDropdownOptions, chargeOnCompanyMappingState.dynamicOptions.opsLineDropdownOptions])

    const memoChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.chargeType || ''}
                fieldValue={currentEditRow?.chargeType}
                fieldLabel={CHARGE_ON_COMPANY_MAPPING_CONSTANT.CHARGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeType'}
                maxLength={60}
                options={chargeOnCompanyMappingState.dynamicOptions.chargeTypeDropdownOptions}
                requiredFieldList={chargeOnCompanyMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeOnCompanyMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_ON_COMPANY_MAPPING_CONSTANT.CHARGE_TYPE, allFormState, chargeOnCompanyMappingState.dynamicOptions.chargeTypeDropdownOptions, chargeOnCompanyMappingVM, currentEditRow?.chargeType, isAdd, isEdit, isSaveClicked])

    const memoSubChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.subChargeType || ''}
                fieldValue={currentEditRow?.subChargeType}
                fieldLabel={CHARGE_ON_COMPANY_MAPPING_CONSTANT.SUB_CHARGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'subChargeType'}
                maxLength={60}
                options={memoSubChgTypeOptions}
                requiredFieldList={chargeOnCompanyMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeOnCompanyMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_ON_COMPANY_MAPPING_CONSTANT.SUB_CHARGE_TYPE, allFormState, chargeOnCompanyMappingVM, currentEditRow?.subChargeType, isAdd, isEdit, isSaveClicked, memoSubChgTypeOptions])

    const memoSoa = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.soa || ''}
                fieldValue={currentEditRow?.soa}
                fieldLabel={CHARGE_ON_COMPANY_MAPPING_CONSTANT.SOA}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'soa'}
                maxLength={60}
                options={chargeOnCompanyMappingState.dynamicOptions.soaDropdownOptions}
                requiredFieldList={chargeOnCompanyMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeOnCompanyMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_ON_COMPANY_MAPPING_CONSTANT.SOA, allFormState, chargeOnCompanyMappingState.dynamicOptions.soaDropdownOptions, chargeOnCompanyMappingVM, currentEditRow?.soa, isAdd, isEdit, isSaveClicked])

    const memoServiceCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.serviceCode || ''}
                fieldValue={currentEditRow?.serviceCode}
                fieldLabel={CHARGE_ON_COMPANY_MAPPING_CONSTANT.SERVICE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'serviceCode'}
                maxLength={60}
                options={chargeOnCompanyMappingState.dynamicOptions.serviceCodeDropdownOptions}
                requiredFieldList={chargeOnCompanyMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeOnCompanyMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_ON_COMPANY_MAPPING_CONSTANT.SERVICE, allFormState, chargeOnCompanyMappingState.dynamicOptions.serviceCodeDropdownOptions, chargeOnCompanyMappingVM, currentEditRow?.serviceCode, isAdd, isEdit, isSaveClicked])

    const memoOpsLine = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.owner || ''}
                fieldValue={currentEditRow?.owner}
                fieldLabel={CHARGE_ON_COMPANY_MAPPING_CONSTANT.OPS_LINE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'owner'}
                maxLength={60}
                options={chargeOnCompanyMappingState.dynamicOptions.opsLineDropdownOptions}
                requiredFieldList={chargeOnCompanyMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeOnCompanyMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_ON_COMPANY_MAPPING_CONSTANT.OPS_LINE, allFormState, chargeOnCompanyMappingState.dynamicOptions.opsLineDropdownOptions, chargeOnCompanyMappingVM, currentEditRow?.owner, isAdd, isEdit, isSaveClicked])

    const memoForwarderReference = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.forwarderReference || ''}
                fieldValue={currentEditRow?.forwarderReference}
                fieldLabel={CHARGE_ON_COMPANY_MAPPING_CONSTANT.FORWARDER_REF}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'forwarderReference'}
                maxLength={50}
                requiredFieldList={chargeOnCompanyMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeOnCompanyMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_ON_COMPANY_MAPPING_CONSTANT.FORWARDER_REF, allFormState, chargeOnCompanyMappingVM, currentEditRow?.forwarderReference, isAdd, isEdit, isSaveClicked])

    const memoCntrStatus = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.cntrStatus || ''}
                fieldValue={currentEditRow?.cntrStatus}
                fieldLabel={CHARGE_ON_COMPANY_MAPPING_CONSTANT.CONTAINER_STATUS}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrStatus'}
                maxLength={60}
                options={statusDropdownOptions}
                requiredFieldList={chargeOnCompanyMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeOnCompanyMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_ON_COMPANY_MAPPING_CONSTANT.CONTAINER_STATUS, allFormState, chargeOnCompanyMappingVM, currentEditRow?.cntrStatus, isAdd, isEdit, isSaveClicked])

    const memoChargeOnCompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.chargeOnCompanyCode || ''}
                fieldValue={currentEditRow?.chargeOnCompanyCode}
                fieldLabel={CHARGE_ON_COMPANY_MAPPING_CONSTANT.CHARGEON_COMPANY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeOnCompanyCode'}
                maxLength={60}
                sort={false}
                isLimitOptions={true}
                options={chargeOnCompanyMappingState.dynamicOptions.chargeOnCompanyDropdownOptions}
                requiredFieldList={chargeOnCompanyMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeOnCompanyMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_ON_COMPANY_MAPPING_CONSTANT.CHARGEON_COMPANY, allFormState, chargeOnCompanyMappingState.dynamicOptions.chargeOnCompanyDropdownOptions, chargeOnCompanyMappingVM, currentEditRow?.chargeOnCompanyCode, isAdd, isEdit, isSaveClicked])

    const memoVesselType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.vesselType || ''}
                fieldValue={currentEditRow?.vesselType}
                fieldLabel={CHARGE_ON_COMPANY_MAPPING_CONSTANT.VESSEL_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'vesselType'}
                maxLength={60}
                options={chargeOnCompanyMappingState.dynamicOptions.vesselTypeDropdownOptions}
                requiredFieldList={chargeOnCompanyMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeOnCompanyMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_ON_COMPANY_MAPPING_CONSTANT.VESSEL_TYPE, allFormState, chargeOnCompanyMappingState.dynamicOptions.vesselTypeDropdownOptions, chargeOnCompanyMappingVM, currentEditRow?.vesselType, isAdd, isEdit, isSaveClicked])

    const memoConsortiumCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.consortiumCode || ''}
                fieldValue={currentEditRow?.consortiumCode}
                fieldLabel={CHARGE_ON_COMPANY_MAPPING_CONSTANT.CONSORTIUM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'consortiumCode'}
                maxLength={60}
                options={chargeOnCompanyMappingState.dynamicOptions.consortiumCodeDropdownOptions}
                requiredFieldList={chargeOnCompanyMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeOnCompanyMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_ON_COMPANY_MAPPING_CONSTANT.CONSORTIUM, allFormState, chargeOnCompanyMappingState.dynamicOptions.consortiumCodeDropdownOptions, chargeOnCompanyMappingVM, currentEditRow?.consortiumCode, isAdd, isEdit, isSaveClicked])

    const memoForwarderCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.forwarderCode || ''}
                fieldValue={currentEditRow?.forwarderCode}
                fieldLabel={CHARGE_ON_COMPANY_MAPPING_CONSTANT.FORWARDER_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'forwarderCode'}
                maxLength={60}
                options={chargeOnCompanyMappingState.dynamicOptions.forwarderCodeDropdownOptions}
                requiredFieldList={chargeOnCompanyMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeOnCompanyMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_ON_COMPANY_MAPPING_CONSTANT.FORWARDER_CODE, allFormState, chargeOnCompanyMappingState.dynamicOptions.forwarderCodeDropdownOptions, chargeOnCompanyMappingVM, currentEditRow?.forwarderCode, isAdd, isEdit, isSaveClicked])

    const memoOperatingTml = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.operatingTml || ''}
                fieldValue={currentEditRow?.operatingTml}
                fieldLabel={CHARGE_ON_COMPANY_MAPPING_CONSTANT.OPERATING_TML}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'operatingTml'}
                maxLength={60}
                options={chargeOnCompanyMappingState.dynamicOptions.operatingTmlDropdownOptions}
                requiredFieldList={chargeOnCompanyMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeOnCompanyMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_ON_COMPANY_MAPPING_CONSTANT.OPERATING_TML, allFormState, chargeOnCompanyMappingState.dynamicOptions.operatingTmlDropdownOptions, chargeOnCompanyMappingVM, currentEditRow?.operatingTml, isAdd, isEdit, isSaveClicked])

    const memoChargeCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={currentEditRow?.chargeCode || ''}
                fieldValue={currentEditRow?.chargeCode}
                fieldLabel={CHARGE_ON_COMPANY_MAPPING_CONSTANT.CHARGE_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeCode'}
                maxLength={60}
                options={chargeOnCompanyMappingState.dynamicOptions.chargeCodeDropdownOptions}
                requiredFieldList={chargeOnCompanyMappingRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeOnCompanyMappingVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_ON_COMPANY_MAPPING_CONSTANT.CHARGE_CODE, allFormState, chargeOnCompanyMappingState.dynamicOptions.chargeCodeDropdownOptions, chargeOnCompanyMappingVM, currentEditRow?.chargeCode, isAdd, isEdit, isSaveClicked])

    const memoActiveInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                fieldKey={"activeInd"}
                requiredFieldList={chargeOnCompanyMappingRequiredFieldList}
                fieldLabel={CHARGE_ON_COMPANY_MAPPING_CONSTANT.ACTIVE_IND}
                fieldType={FieldType.TEXT}
                isReadOnly={true}
                onFieldChange={() => { }} />
            <HPHCheckbox
                label={""}
                checked={currentEditRow?.activeInd === 'Y'}
                disabled={!(isAdd || isEdit)}
                onChange={(e) => chargeOnCompanyMappingVM.onCheckboxChange(e.checked, "activeInd")}
            />
        </div>
        , [CHARGE_ON_COMPANY_MAPPING_CONSTANT.ACTIVE_IND, chargeOnCompanyMappingVM, currentEditRow?.activeInd, isAdd, isEdit])

    const handleEdit = useCallback(() => {
        chargeOnCompanyMappingVM.onEditClick();
    }, [chargeOnCompanyMappingVM]);

    const handleReset = useCallback(() => {
        chargeOnCompanyMappingVM.onResetClick(isAdd);
    }, [chargeOnCompanyMappingVM, isAdd]);

    return <>
        <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
            <Sidebarheader style={{ width: '100%' }}>
                {isLoading && <Loader Indicator="Spinner" size="Medium" />}
                <Breadcrumb>
                    <HPHBreadcrumb breadcrumbData={[{ title: ChargeOnCompanyMappingConstant.Title.CATEGORY },
                    { title: ChargeOnCompanyMappingConstant.Title.TITLE }]} onCurrentClick={() => { }}>
                    </HPHBreadcrumb>
                </Breadcrumb>
                <StyledAction>
                    <>
                        {allowUpdate && (!(isAdd || isEdit)) && <NbisIconButton fileName='Icon-pen' size='medium' disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Edit'} onClick={handleEdit} />}
                        {(isAdd || isEdit) && <IconButton fileName="Icon-reset" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={() => handleReset()} />}
                        <IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement='bottom' toolTipText={'Close'} onClick={() => handClose()} />
                        {(isAdd || isEdit) && <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />}
                    </>
                </StyledAction>
            </Sidebarheader>

            <div className={'add-edit-form'} style={{ height: 'calc(100vh - 125px)', maxHeight: 'calc(100vh - 125px)', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <div className={'im-flex-row'}>
                            <div className={'flex-row-item-stretch'}>
                                <SidebarTitle>
                                    {isAdd && "New Charge-On Company Setting"}
                                    {!isAdd && (currentEditRow.priority + "/" + currentEditRow.chargeOnCompanyCode)}
                                </SidebarTitle>
                                {<SidebarCaption>"All fields are required unless indicated as 'optional'"</SidebarCaption>}
                            </div>
                        </div>
                        <br />
                        <HPHGroupTitle titleText={ChargeOnCompanyMappingConstant.Title.MAPPING_FROM} />
                        <CriteriaItemContainer>
                            {memoChargeType}
                            {memoSubChargeType}
                            {memoOpsLine}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoCntrStatus}
                            {memoForwarderCode}
                            {memoForwarderReference}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoChargeCode}
                            {memoServiceCode}
                            {memoVesselType}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoConsortiumCode}
                            {memoOperatingTml}
                            {memoSoa}
                        </CriteriaItemContainer>

                        <HPHGroupTitle titleText={ChargeOnCompanyMappingConstant.Title.MAPPING_TO} />
                        <CriteriaItemContainer>
                            {memoChargeOnCompanyCode}
                            {memoActiveInd}
                        </CriteriaItemContainer>
                    </div>
                </div>
            </div>
        </StyledSidebar>
    </>
}

export default memo(ChargeOnCompanyMappingEditPanel);
